import { Controller } from 'stimulus';

class FilterPreference extends Controller {
  onSelectChange() {
    const formData = new FormData(this.element);

    this.data.get('only').split(',').forEach((onlyAttribute) => {
      formData.append('only[]', onlyAttribute);
    });

    const event = new CustomEvent('update');
    this.element.dispatchEvent(event);

    $.ajax({
      url: this.element.getAttribute('action'),
      type: this.element.getAttribute('method'),
      processData: false,
      contentType: false,
      data: formData,
      complete: () => {
        const storedEvent = new CustomEvent('stored');
        this.element.dispatchEvent(storedEvent);
      },
    });
  }
}

FilterPreference.targets = [
  //
];

export default FilterPreference;
